const SiteDesignPageType = {
  Custom: "CUSTOM",
  JobDescription: "JOB_DESCRIPTION",
  Home: "HOME"
};

export { SiteDesignPageType };
//# sourceMappingURL=site-design-page-type.mjs.map
